<div class="main-container">
  <div class="grid-container" id="nareport-grid-container">
      <div class="top-toolbar">
          <div class="float-left ml-4">
            @if (taxyearLoaded) {
              <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
                @for (item of taxYearItems; track item.value) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            }

            <button class="export-btn" (click)="exportToExcel()">
              <i class="Appkit4-icon icon-save-outline"></i>
              Export to Excel
            </button>
          </div>
      </div>

      <div class="dst-mat-grid-layout">
        @if (loading) {
          <div class="dst-mat-grid-loading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        <div class="dst-mat-grid">
          <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort class="dst-mat-table">
            <ng-container matColumnDef="TAXYEAR">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('TAXYEAR'))">
                {{ getCol('TAXYEAR').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getCol('TAXYEAR'))">
                <span>{{ rowData.TAXYEAR }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="LEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('LEID'))">
                {{ getCol('LEID').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getCol('LEID'))">
                <span>{{ rowData.LEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FORMNAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('FORMNAME'))">
                {{ getCol('FORMNAME').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(getCol('FORMNAME'))">
                <span>{{ rowData.FORMNAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="CODESECTIONNAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('CODESECTIONNAME'))">
                {{ getCol('CODESECTIONNAME').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getCol('CODESECTIONNAME'))">
                <span>{{ rowData.CODESECTIONNAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BUSINESSNAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('BUSINESSNAME'))">
                {{ getCol('BUSINESSNAME').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getCol('BUSINESSNAME'))">
                <span>{{ rowData.BUSINESSNAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ENTITYNAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('ENTITYNAME'))">
                {{ getCol('ENTITYNAME').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(getCol('ENTITYNAME'))">
                <span>{{ rowData.ENTITYNAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="IGNOREREASON">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('IGNOREREASON'))">
                {{ getCol('IGNOREREASON').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getCol('IGNOREREASON'))">
                <span>{{ rowData.IGNOREREASON }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="IGNOREREASONDETAILS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getCol('IGNOREREASONDETAILS'))">
                {{ getCol('IGNOREREASONDETAILS').header }}
              </th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(getCol('IGNOREREASONDETAILS'))">
                <span>{{ rowData.IGNOREREASONDETAILS }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell dst-mat-no-records" [attr.colspan]="displayedColumns.length">
                <span>No records.</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
  </div>
</div>
